import React from 'react';

import {Objects} from "components";

import {Button, Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";

import {ListItemIcon, ListItemText, Menu, MenuItem, TextField} from '@material-ui/core';
import {Link, withRouter} from "react-router-dom";
import PropTypes from "prop-types";
import Lockable from "components/Lockable";
import UniversalModalOverride from "components/UniversalModalOverride";
import Framework from "@beardeddevops/react.framework";
import Access from "constants/Access";
import API from "@beardeddevops/react.api";
import {Types} from "components";



class NavLeftList extends Lockable {
	static propTypes = {
		headerModals: PropTypes.any
	};

	constructor(props) {
		super(props);
		this.state.anchorEl = null;
		this.state.anchorE2 = null;
		this.state.firearmModal = false;
		this.state.firearmSerial = '';
		this.state.backdrop = true;
		this.state.modalAcquisition = false;
		this.state.closeModal = 0;
		this.state.bypass = false;
	}

	componentDidMount() {
		if(window.localStorage.getItem('kioskLogin') === "true"){
			this.handleSetPin(1);
			window.localStorage.setItem('kioskLogin', "false");
		}
	}

	handleRoute = (e) => {
		const route = e.currentTarget.id;

		this.props.history.push(route);
		this.setState({
			anchorEl: null,
			anchorE2: null,
		});
	};

	handleOpen = (e) => {
		const el = e.currentTarget.name;

		this.setState({
			[el]: e.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorEl: null,
			anchorE2: null
		});
	};

	handleToggleModal = (e) => {
		this.handleClose();
		this.props.rootState.triggerAction('handleToggleModal', e);
	}
	handleReportClose = (e) => {
		this.props.rootState.triggerAction('handleReportClose', e);
	}

	redirectTo = (objectType) => () => {
		//push a search param that will be picked up to reload the collection table
		this.props.history.push({
			pathname: objectType,
			search: "?reload=True"
		});
	}

	handleFirearmTrace = async (e) => {
		e.preventDefault();

		this.props.history.push({
			pathname: '/firearm_traces',
			search: `?=${this.state.firearmSerial}`
		});

		this.onToggle();
		this.state.firearmSerial = '';
		
	}

	onToggle = () => {
		this.setState({firearmModal: !this.state.firearmModal});
	}

	handleDataChange = event => {
		this.setState({[event.target.name]: event.target.value});
	};

	handlingToggle = () => {
		this.handleClose();
		if (this.state.backdrop !== 'static'){
			this.setState({modalAcquisition: !this.state.modalAcquisition});
		} else {
			if (this.state.closeModal > 0 || this.state.bypass){
				this.setState({closeModal: 0});
				this.setState({backdrop: true});
				this.setState({modalAcquisition: !this.state.modalAcquisition});
			} else {
				this.setState({closeModal: 1});
				API.Toast.info('You have unsaved changes. Click again to close modal.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
			}
		}
	}

	render() {
		const {anchorEl, anchorE2} = this.state;
		let {rootState} = this.props;
		let {userAccess} = rootState;
		return (
			<div>
			{rootState.kioskMode !== '1' &&
					<ul className="list-unstyled float-right" id={"nav-list-left"}>
						<li style={{marginRight: '10px'}}>

							{userAccess <= Access.Supervisor && <Button
								name="anchorEl"
								color={'none'}
								aria-owns={anchorEl ? 'bound-book' : null}
								aria-haspopup="true"
								onClick={this.handleOpen}
								className="md-button header-btn menu-button tablet-button"
							>
								<i className={'fa fa-book'}/>
								<Link to={"/locations"}>&nbsp;&nbsp;Bound Books&nbsp;&nbsp;</Link>
								<i className={'fa fa-angle-down'}/>
							</Button>}
							<Menu
								id="bound-book"
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={this.handleClose}
								getContentAnchorEl={null}
								anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
								transformOrigin={{horizontal: 'left', vertical: 'top'}}
							>
								{rootState.locations
									.filter(
										/**
										 * @param {Locations_Object} location
										 * @returns {boolean}
										 */
										location => !location.archived)
									.map(
										/**
										 * @param {Locations_Object} location
										 * @param key
										 */
										(location, key) =>
											<div key={key}>
												<MenuItem
													id={'/locations/' + location.binary_id + '-' + location.pkey}
													data-id={'locations-' + location.binary_id + '-' + location.pkey}
													onClick={this.handleRoute}>
													<ListItemIcon><i className={"fa fa-building"}/></ListItemIcon>
													<ListItemText inset primary={location.name_display || location.name}/>
												</MenuItem>

												<MenuItem
													key={key + '0'}
													id={'/locations/' + location.binary_id + '-' + location.pkey}
													data-id={'primary-bound-book-' + location.binary_id + '-' + location.pkey}
													onClick={this.handleRoute}>
													<ListItemIcon><i className={"fa fa-book"}/></ListItemIcon>
													<ListItemText inset primary={location.bound_book || 'Primary'}/>
												</MenuItem>
												{location.location_bound_bookss.map((bound_book, cKey) => {
													cKey++;
													return (
														<div key={key + cKey}>
															<MenuItem
																id={'/locations/' + location.binary_id + '-' + location.pkey + '/' + bound_book.binary_id + '-' + bound_book.pkey}
																data-id={'bound-book-' + location.binary_id + '-' + location.pkey + '/' + bound_book.binary_id + '-' + bound_book.pkey}
																onClick={this.handleRoute}>
																<ListItemIcon><i className={"fa fa-book"}/></ListItemIcon>
																<ListItemText inset primary={bound_book.name}/>
															</MenuItem>
														</div>
													)
												})}
												<hr/>
											</div>
									)
								}
							</Menu>

							<Button
								name="anchorE2"
								color={'none'}
								aria-owns={anchorE2 ? 'quick-transactions' : null}
								aria-haspopup="true"
								onClick={this.handleOpen}
								className="md-button header-btn menu-button laptop-button"
							>
								<i className={'fa fa-check-square-o'} data-cy={"quick-transactions-button"}/>
								<span>&nbsp;&nbsp;Quick Transactions&nbsp;&nbsp;</span>
								<i className={'fa fa-angle-down'}/>
							</Button>
							<Menu
								id="quick-transactions"
								anchorEl={anchorE2}
								open={Boolean(anchorE2)}
								onClose={this.handleClose}
								getContentAnchorEl={null}
								anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
								transformOrigin={{horizontal: 'left', vertical: 'top'}}
							>
								{userAccess <= Access.Supervisor && <MenuItem id="acquisition" onClick={this.handlingToggle}>
									<ListItemIcon><i className={"fa fa-download fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Acquisition"/>
								</MenuItem>}
								<MenuItem id="/dispositions/one_page" onClick={this.handleRoute}>
									<ListItemIcon><i className={"fa fa-file-pdf-o fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Start Kiosk"/>
								</MenuItem>
								{userAccess <= Access.Supervisor && <MenuItem id="disposition" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-upload fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Quick Disposition"/>
								</MenuItem>}
								{userAccess <= Access.Supervisor && <MenuItem id="disposition" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-upload fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Gunsmith Disposition"/>
								</MenuItem>}
								{userAccess <= Access.Supervisor && <MenuItem id="transfer" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-random fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="FFL To FFL Transfer"/>
								</MenuItem>}
								{userAccess <= Access.Manager && <MenuItem id="loss" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-question fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Lost / Stolen"/>
								</MenuItem>}
								{userAccess <= Access.Manager && <MenuItem id="destroy" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-times fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Destroyed"/>
								</MenuItem>}
								{userAccess <= Access.Manager && <MenuItem id="rental" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-tags fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Rental"/>
								</MenuItem>}
								{userAccess <= Access.Manager && <MenuItem id="reservation" onClick={this.handleToggleModal}>
									<ListItemIcon><i className={"fa fa-calendar-check-o fa-lg"}/></ListItemIcon>
									<ListItemText inset primary="Reservation"/>
								</MenuItem>}
							</Menu>

							{/*Don't pass toggle if passing showModal*/}
							<UniversalModalOverride
								showModal={this.state.modalAcquisition}
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Acquisition"}
								object={Objects.Acquisition}
								reportClose={this.handleReportClose}
								afterSave={() => {
									this.setState({bypass: false});
									if(this.props.location.pathname === '/acquisitions') {
										//triggers refresh via the transaction collection component
										this.props.history.push({search: "?reload=True"});
									} else {
										this.props.history.push('/acquisitions');
									}
								}}
								size={"xl"}
								handleToggle={this.handlingToggle}
								objectProps={{
									modalState: this.state['modalAcquisition'],
									scannedCode: this.props.headerModals.acquisition ? this.props.scannedCode : null,
									setBackdrop: (backdrop) => this.setState({backdrop}),
									setBypass: (bypass) => this.setState({bypass})
								}}
							/>

							<UniversalModalOverride
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Disposition"}
								object={Objects.DispositionAdd}
								toggle={this.props.headerModals.disposition}
								reportClose={this.handleReportClose}
								afterSave={() => this.props.history.push('/dispositions')}
								objectProps={{scannedCode: this.props.headerModals.disposition ? this.props.scannedCode : null}}
							/>

							<UniversalModalOverride
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Transfer"}
								object={Objects.Transfer}
								toggle={this.props.headerModals.transfer}
								reportClose={this.handleReportClose}
								afterSave={() => this.props.history.push('/transfers')}
								objectProps={{scannedCode: this.props.headerModals.transfer ? this.props.scannedCode : null}}
							/>

							<UniversalModalOverride
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Loss"}
								object={Objects.Loss}
								toggle={this.props.headerModals.loss}
								reportClose={this.handleReportClose}
								afterSave={() => this.props.history.push('/losses')}
								objectProps={{scannedCode: this.props.headerModals.loss ? this.props.scannedCode : null}}
							/>

							<UniversalModalOverride
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Destroy"}
								object={Objects.Destroy}
								toggle={this.props.headerModals.destroy}
								reportClose={this.handleReportClose}
								afterSave={() => this.props.history.push('/destroys')}
								objectProps={{scannedCode: this.props.headerModals.destroy ? this.props.scannedCode : null}}
							/>

							<UniversalModalOverride
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Rental"}
								object={Objects.Rental}
								toggle={this.props.headerModals.rental}
								reportClose={this.handleReportClose}
								afterSave={() => this.props.history.push('/rentals')}
								objectProps={{scannedCode: this.props.headerModals.rental ? this.props.scannedCode : null}}
							/>

							<UniversalModalOverride
								locations={rootState.locations}
								states={rootState.states}
								history={this.props.history}
								name={"Reservation"}
								object={Objects.Reservation}
								toggle={this.props.headerModals.reservation}
								reportClose={this.handleReportClose}
								afterSave={() => this.props.history.push('/reservations')}
								objectProps={{scannedCode: this.props.headerModals.reservation ? this.props.scannedCode : null}}
							/>

							<Modal
								isOpen={this.state.firearmModal}
								toggle={this.onToggle}
								size={'sm'}
								backdrop={true}>
								<form onSubmit={this.handleFirearmTrace}>
									<ModalHeader toggle={this.onToggle}>
										Firearm Trace
									</ModalHeader>
									<ModalBody>
										<TextField
											fullWidth
											margin="dense"
											variant="outlined"
											name="firearmSerial"
											label="Serial Number"
											value={this.state.firearmSerial}
											onChange={this.handleDataChange}
										/>
									</ModalBody>
									<ModalFooter>
										<Button color="secondary" onClick={this.onToggle}>Cancel</Button>
										<Button color="info" onClick={this.handleFirearmTrace}>Trace</Button>
										{/*{submitLabel ?*/}
										{/*	<Button*/}
										{/*		data-id={"update-add-" + name.toLowerCase().replace(/ /gi, '-')}*/}
										{/*		color="primary" onClick={onSubmit}>*/}
										{/*		{submitLabel}*/}

									</ModalFooter>
								</form>
							</Modal>

							{ !this.props.rootState.all_locations_expired &&
								<Button color={'none'} onClick={() => this.handleSetPin(1, false, false)} className="md-button header-btn">
									<i className={"fa fa-lock"}/>&nbsp;&nbsp;Kiosk Mode</Button>
							}

							{ !this.props.rootState.all_locations_expired &&
								<Button color={'none'} onClick={() => this.handleSetPin(2)} className="md-button header-btn">
									<i className={"fa fa-lock"}/>&nbsp;&nbsp;IOI Mode</Button>
							}

							{userAccess <= Access.Manager && <Link to={'/point_of_sales'}>
								<Button color={'none'} data-id={"top-point-of-sales"} className="md-button header-btn sm-button">
									<i className={"fa fa-credit-card-alt"}/>&nbsp;&nbsp;Point Of Sale</Button>
							</Link>}

							<Button color={'none'} onClick={() => this.onToggle()} className="md-button header-btn">
								<i className={"fa fa-arrows-alt"}/>&nbsp;&nbsp;Firearm Trace</Button>


						</li>
					</ul>
			}
			</div>
		);
	}
}

export default Framework.Components.withRootState(withRouter(NavLeftList));
